const _excluded = ["info", "forceOpen", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useState } from 'react';
import cn from 'classnames';
import { Tooltip } from "../Tooltip";
import styles from "./InfoIcon.module.scss";

/** Renders an info-icon with a built-in tooltip. */
export function InfoIcon(props) {
  const {
    info,
    forceOpen,
    className
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/React.createElement(Tooltip, {
    open: forceOpen || isOpen,
    placement: "top",
    title: info,
    onOpen: () => setIsOpen(true),
    onClose: () => setIsOpen(false)
  }, /*#__PURE__*/React.createElement("span", _extends({}, rest, {
    className: cn(styles.root, className),
    tabIndex: 0
  }), /*#__PURE__*/React.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.42069 10.1337H8.50679V11.2H7.42069V10.1337ZM8.295 4.82347C7.17632 4.66352 6.18796 5.34063 5.88929 6.31098C5.79154 6.62021 6.03048 6.93478 6.36174 6.93478H6.47035C6.693 6.93478 6.87221 6.78016 6.94824 6.57756C7.12201 6.10305 7.63791 5.77782 8.19725 5.89512C8.71315 6.00175 9.09329 6.49759 9.04984 7.01475C8.99554 7.72918 8.1701 7.8838 7.71937 8.55025C7.71937 8.55558 7.71394 8.55558 7.71394 8.56091C7.70851 8.57158 7.70308 8.57691 7.69765 8.58757C7.64877 8.66754 7.5999 8.75818 7.56188 8.85415C7.55645 8.87014 7.54559 8.88081 7.54016 8.8968C7.53473 8.90746 7.53473 8.91813 7.5293 8.93412C7.46413 9.1154 7.42069 9.33399 7.42069 9.60057H8.50679C8.50679 9.37664 8.56653 9.19004 8.65885 9.03009C8.66971 9.0141 8.67514 8.9981 8.686 8.98211C8.72944 8.90746 8.78375 8.83815 8.83805 8.77418C8.84348 8.76884 8.84892 8.75818 8.85435 8.75285C8.90865 8.68887 8.96839 8.63022 9.03355 8.57158C9.55488 8.0864 10.2608 7.69186 10.1142 6.67353C9.98389 5.74583 9.23991 4.96209 8.295 4.82347Z",
    fill: "currentColor"
  }))));
}